<canvas id="container" #container width="120" height="60">
  Your browser is unfortunately not supported.
</canvas>